export function EmptyValue() {
  return (
    <span className="text-fg-subtle">
      <span aria-hidden="true">—</span>
      <span className="sr-only">None</span>
    </span>
  );
}
